import { Box, Button } from '@mui/material';
import CircularProgress from "@mui/material/CircularProgress";
import {darken, lighten} from "@mui/material";

export default function ActionButton({ type = "submit", label, action, disabled, sx, withIcon = true, buttonBordered, useBorderColor='#003300', useDark, iconStyle }) {
    return(
        <Box sx={{height: '40px', ...sx}}>
            <Button
                sx={buttonBordered ?
                    {
                        ...styles.buttonBordered, ...sx,
                        ...{
                            color: useBorderColor,
                            borderColor: useBorderColor,
                            ':hover': {
                                backgroundColor: '#ffffff',
                                color: darken(useBorderColor, 0.9),
                                borderColor: darken(useBorderColor, 0.9)
                            },
                            ':disabled': {
                                backgroundColor: '#ffffff',
                                color: lighten(useBorderColor, 0.55),
                                borderColor: lighten(useBorderColor, 0.55)
                            },
                            ':active': {
                                color: useBorderColor
                            },
                        }
                    }
                    : (useDark ? styles.buttonColoredDark : {...styles.buttonColored, ...sx})}
                type={type}
                onClick={action}
                variant="contained"
                disableElevation
                disabled={disabled}
                endIcon={disabled && withIcon &&
                    <CircularProgress size={15} sx={{ color: '#ffffff', marginLeft: '10px', ...iconStyle}}/>} >
                {label}
            </Button>
        </Box>
    )
}

const styles = {
    buttonColored: {
        width: '100%',
        fontSize: '15px',
        padding: '11px 24px',
        color: '#fff',
        fontFamily: 'FustatBold',
        lineHeight: 1,
        textTransform: 'none',
        borderRadius: '50px',
        backgroundColor: '#003300',
        ':hover': {
            backgroundColor: '#002300',
            color: '#fff',
        },
        ':disabled': {
            color: '#cccccc',
            backgroundColor: '#003300b0'
        },
        ':focus': {
            outline: '0'
        }
    },
    buttonColoredDark: {
        width: '100%',
        fontSize: '15px',
        padding: '11px 24px',
        color: '#fff',
        fontFamily: 'FustatBold',
        lineHeight: 1,
        textTransform: 'none',
        borderRadius: '50px',
        backgroundColor: '#2f2e2a',
        ':hover': {
            backgroundColor: '#1f1d1c',
            color: '#fff',
        },
        ':disabled': {
            color: '#fff',
            backgroundColor: '#2F2E2AC0'
        },
        ':focus': {
            outline: '0'
        }
    },
    buttonBordered: {
        width: '100%',
        fontSize: '15px',
        padding: '9px 25px',
        color: '#003300',
        fontFamily: 'FustatBold',
        lineHeight: 1,
        textTransform: 'none',
        borderRadius: '50px',
        backgroundColor: '#ffffff',
        border: '1.5px solid #003300',
        textDecoration: 'none',
        ':hover': {
            backgroundColor: '#ffffff',
            color: '#002900',
        },
        ':disabled': {
            color: '#94a694',
            backgroundColor: '#ffffff',
            border: '1px solid #94a694'
        },
        ':focus': {
            outline: '0'
        }
    },
}